import React from 'react';
import i18n from 'i18next';
import cn from 'classnames';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import { func, number, oneOf, string } from 'prop-types';

import { TIME_MODIFIER_VARIANTS } from '../Toolbar/components/TimeModifier/constants';

import styles from './styles.module.scss';
import { getNextValue } from './utils';
import { ICONS } from './constants';

function NumberInput({ onChange, value, max, min, className, name, variant, label, ...inputProps }) {
  const subtract = () =>
    onChange(
      getNextValue(value, -1, (nextValue) => nextValue < min),
      name
    );
  const add = () =>
    onChange(
      getNextValue(value, 1, (nextValue) => nextValue > max),
      name
    );

  const getActionsButtons = (variant, onClick, Icon) => {
    const variants = {
      [TIME_MODIFIER_VARIANTS.rounded]: (
        <IconButton onClick={onClick} color="primary">
          {typeof Icon === 'string' ? Icon : <Icon />}
        </IconButton>
      ),
      [TIME_MODIFIER_VARIANTS.square]: (
        <button type="button" onClick={onClick}>
          {typeof Icon === 'string' ? Icon : <Icon />}
        </button>
      )
    };

    return variants[variant];
  };

  return (
    <div className={cn(styles[`container${variant}`], className)}>
      {getActionsButtons(variant, subtract, ICONS[variant].subtract)}
      {variant === TIME_MODIFIER_VARIANTS.rounded ? (
        <TextField
          name={name}
          type="number"
          value={value}
          label={i18n.t(label)}
          size="small"
          sx={{ width: '90px' }}
          onChange={({ target }) => onChange(Number(target.value), name)}
          {...inputProps}
        />
      ) : (
        <input
          name={name}
          type="number"
          value={value}
          onChange={({ target }) => onChange(Number(target.value), name)}
          {...inputProps}
        />
      )}
      {getActionsButtons(variant, add, ICONS[variant].add)}
    </div>
  );
}

NumberInput.propTypes = {
  name: string.isRequired,
  value: number.isRequired,
  onChange: func.isRequired,
  className: string,
  label: string,
  max: number,
  min: number,
  variant: oneOf([TIME_MODIFIER_VARIANTS.rounded, TIME_MODIFIER_VARIANTS.square])
};

export default NumberInput;
